import { useEffect, useState } from 'react';
import type { FeatureFlag } from '@pantry/analytics';

export interface FeatureFlagAdapter {
  getFlag: (flag: FeatureFlag) => boolean | null;
  subscribe: (callback: () => void) => (() => void) | void;
}

export function useFeatureFlagCore(flag: FeatureFlag, adapter: FeatureFlagAdapter): boolean | null {
  const [enabled, setEnabled] = useState<boolean | null>(() => adapter.getFlag(flag));
  useEffect(() => {
    // Re-sync flag value when flag name or adapter changes after mount
    setEnabled(adapter.getFlag(flag));
    const unsubscribe = adapter.subscribe(() => {
      setEnabled(adapter.getFlag(flag));
    });
    return () => {
      unsubscribe?.();
    };
  }, [flag, adapter]);
  return enabled;
}
